<div class="main" *ngIf="!selectedCampaignId">
  <div class="sidebar full-width">
    <div class="top-holder">
      <form
        action="#"
        class="search-filter"
        #searchForm="ngForm"
        (ngSubmit)="$event.preventDefault();submitSearch()"
        [ngClass]="{'search-filter-focused': searchFilterFocused}">
        <label for="search-filter-field" class="icon" (click)="submitSearch()">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"/></svg>
        </label>
        <input
          [(ngModel)]="searchString"
          name="searchString"
          type="text"
          class="txt"
          id="search-filter-field"
          (focus)="searchFilterFocused = true"
          placeholder="Find a campaign by subject"/>
      </form>
      <mat-form-field appearance="fill" class="status-filter dark-theme">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="statusFilter" (selectionChange)="submitSearch()">
          <mat-option value="">All</mat-option>
          <mat-option value="draft">Draft</mat-option>
          <mat-option value="prepared">Prepared</mat-option>
          <mat-option value="queued">Queued</mat-option>
          <mat-option value="sending">Sending</mat-option>
          <mat-option value="partially_failed">Partially failed</mat-option>
          <mat-option value="completed">Completed</mat-option>
          <mat-option value="failed">Failed</mat-option>
          <mat-option value="cancelled">Cancelled</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="campaigns-info">
        <strong>{{totalCampaigns}} Campaigns</strong>
        <button class="button" (click)="displayNewCampaignDialog()">+ New Campaign</button>
      </div>
    </div>
    <div class="campaigns-holder">
      <app-loader *ngIf="loadingCampaigns"></app-loader>
      <table class="campaigns-table" *ngIf="!loadingCampaigns">
        <thead>
          <tr>
            <th>Subject</th>
            <th>From</th>
            <th>Status</th>
            <th>Progress</th>
            <th>Intended</th>
            <th>Accepted (SMTP)</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let campaign of campaigns; trackBy:campaignTrackBy" (click)="viewCampaign(campaign)">
            <td>{{campaign.subject}}</td>
            <td>{{campaign.from_email}}</td>
            <td>{{campaign.status}}</td>
            <td>{{campaign.progress_percent}}%</td>
            <td>{{campaign.intended_recipient_count}}</td>
            <td>{{campaign.accepted_recipient_count}}</td>
            <td>{{campaign.created_at | date:'short'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="campaigns-pagination" *ngIf="!loadingCampaigns && campaignsNumberOfPages > 1">
      <button class="button" (click)="setPage(currentCampaignsPage - 1)" [disabled]="currentCampaignsPage <= 1">Prev</button>
      <input type="text" class="txt" [(ngModel)]="currentCampaignsPage">
      <button class="button btn-next" (click)="setPage(currentCampaignsPage + 1)" [disabled]="campaignsNumberOfPages <= currentCampaignsPage">Next</button>
    </div>
  </div>
</div>

<app-campaign-detail
  *ngIf="selectedCampaignId"
  [campaignId]="selectedCampaignId"
  (closed)="closeDetail()"
></app-campaign-detail>
